import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable, of } from "rxjs";

// models
import { Subject } from "rxjs";

@Injectable()
export class StateService {


  // tcrvcr order state
  private tcrvcrRunning: boolean = false;
  private tcrvcrRunningUpdate: Subject<boolean> = new Subject<boolean>();

  // provision state
  private provisionLoading: boolean = false;
  private provisionLoadingUpdate: Subject<boolean> = new Subject<boolean>();
  private provisionSaving = false;
  private provisionBusyUpdate = new BehaviorSubject<boolean>(false);

  insertTcrVcrRunning(data: boolean) {
    this.tcrvcrRunning = data;
    this.tcrvcrRunningUpdate.next(this.tcrvcrRunning);
  }

  getTcrVcrRunningUpdates(): Observable<boolean> {
    return this.tcrvcrRunningUpdate.asObservable();
  }

  insertProvisionLoading(data: boolean) {
    this.provisionLoading = data;
    this.provisionLoadingUpdate.next(this.provisionLoading);
    this.provisionBusyUpdate.next(this.provisionLoading || this.provisionSaving);
  }

  getProvisionLoadingUpdate(): Observable<boolean> {
    return this.provisionLoadingUpdate.asObservable();
  }

  insertProvisionSaving(data: boolean) {
    this.provisionSaving = data;
    this.provisionBusyUpdate.next(this.provisionLoading || this.provisionSaving);
  }

  getProvisionBusyUpdates(): Observable<boolean> {
    return this.provisionBusyUpdate.asObservable();
  }


  clearData(): void{
    this.insertTcrVcrRunning(false);
    
  }
}

